import { getUiVersion } from '../../../helpers/RequestHelper';

export const DEFAULT_HEADERS = {
  'x-custom-ui-version': getUiVersion(),
  Accept: 'application/json',
  'Content-Type': 'application/json'
};
